import { StringEqualsComparatorEvaluator, StringNotEqualsComparatorEvaluator } from '@leverege/ui-attributes';
import ResourceEnumEqualsComparator from "./ResourceEnumEqualsComparator.js";
import ResourceEnumEqualsComparatorEditor from "./ResourceEnumEqualsComparatorEditor.js";
import ResourceEnumEqualsComparatorFilterConverter from "./ResourceEnumEqualsComparatorFilterConverter.js";
import ResourceEnumNotEqualsComparator from "./ResourceEnumNotEqualsComparator.js";
import ResourceEnumNotEqualsComparatorEditor from "./ResourceEnumNotEqualsComparatorEditor.js";
import ResourceEnumNotEqualsComparatorFilterConverter from "./ResourceEnumNotEqualsComparatorFilterConverter.js";
export default {
  install(molten) {
    molten.addPlugin('AttributeConditionComparator', ResourceEnumEqualsComparator);
    molten.addPlugin('ConditionEvaluator', {
      type: ResourceEnumEqualsComparator.TYPE,
      evaluator: StringEqualsComparatorEvaluator
    });
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: ResourceEnumEqualsComparator.TYPE,
      editor: ResourceEnumEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', ResourceEnumEqualsComparatorFilterConverter);
    molten.addPlugin('AttributeConditionComparator', ResourceEnumNotEqualsComparator);
    molten.addPlugin('ConditionEvaluator', {
      type: ResourceEnumNotEqualsComparator.TYPE,
      evaluator: StringNotEqualsComparatorEvaluator
    });
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: ResourceEnumNotEqualsComparator.TYPE,
      editor: ResourceEnumNotEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', ResourceEnumNotEqualsComparatorFilterConverter);
  }
};